import { action as apiAction } from 'api/Api'
import {
  positionItem,
  addItem,
  removeItem
} from '../redux/elements'
import sweetalert from 'sweetalert2'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  documentListItemId: number
  documentListId: number
  position: number
}

const requestPositionDocumentListItem = (payload: Payload) => async (dispatch, getState) => {
  const { cardId, documentListItemId, documentListId, position } = payload

  let currentDocumentListId

  const state = getState()

  const elements = state['view-card'].elements[cardId].elements
  const elementsById = state['view-card'].elements.elementsById

  for (let i = 0, length = elements.length; i < length; i++) {
    const documentList = elementsById[elements[i]]

    if (documentList.elementName === '/Data/DocumentsList' && documentList.items.indexOf(documentListItemId) !== -1) {
      currentDocumentListId = documentList.id
      break
    }
  }

  if (documentListId === currentDocumentListId) {
    const optimisticAction = optimisticDispatch(dispatch, positionItem({
      elementId: documentListId,
      itemId: documentListItemId,
      index: position
    }))

    try {
      await apiAction('PositionDocumentsListItem', {
        id: documentListItemId,
        position
      })

      optimisticAction.commit()
    } catch (error) {
      optimisticAction.revert()

      throw error
    }
  } else {
    const optimisticAction = optimisticDispatch(dispatch, [
      removeItem({
        elementId: currentDocumentListId,
        itemId: documentListItemId
      }),
      addItem({
        elementId: documentListId,
        itemId: documentListItemId,
        index: position
      })
    ])

    try {
      await apiAction('ChangeDocumentsListItemParent', {
        containerFromId: currentDocumentListId,
        containerToId: documentListId,
        id: documentListItemId,
        position
      })

      optimisticAction.commit()
    } catch (error) {
      optimisticAction.revert()

      if (error.code === 300) {
        const state = getState()
        try {
          await sweetalert({
            text: state.kanbo.locale.messages['DOCUMENT_LIST_ADD_DOCUMENT_DUPLICATE'],
            type: 'info'
          })
        } catch (e) {}
      } else {
        throw error
      }
    }
  }
}

export default requestPositionDocumentListItem
